import apis from './list'
import store from 'src/store'
import axios from 'axios'
import { getCookie } from 'src/store/utils';
import router from '@/router'
import Vue from 'vue';
const unMessageMap = [
  '/TrendyScm-rest/rest/debit/order/create'
]
const excludeToken = ['/app-scm-plugin/ad/login']
axios.defaults.timeout = 5 * 60 * 1000;


axios.interceptors.response.use(response => {
  let data = response.data
  if (data.code == -10) { // token过期
    Vue.prototype.$message({type: 'error', message: data.message})
    setTimeout(() => {
      if(!response.request.responseURL.includes('/ad/login')) { // 非登录页面跳转登录
        store.dispatch('logout', store.state.userInfo && store.state.userInfo.id)
        router.push('/login')
      }
    }, 100);
    return;
  } else {
    return response
  }
}, error => {
  if (error.response) {
    // HTTP错误，根据状态码处理
    const statusCode = error.response.status;
    const responseData = error.response.data;

    if (statusCode >= 400 && statusCode < 500) {
      // 处理HTTP 4xx 错误
      // 提示用户请求有问题
      Vue.prototype.$message({type: 'error', message: 'Client  Error:' + responseData});
    } else if (statusCode >= 500 && statusCode < 600) {
      // 处理HTTP 5xx 错误
      // 提示用户服务器内部错误
      Vue.prototype.$message({type: 'error', message: 'Server Error:' + responseData});
    }
  } else if (error.message === 'Network Error') {
    // 网络错误
    // 提示用户无法连接到服务器
    Vue.prototype.$message({type: 'error', message: 'Networ Error:' + responseData});
  } else {
    // 其他错误
    Vue.prototype.$message({type: 'error', message: 'Error:' +  error.message});
  }
  return Promise.reject(error);
})

// 整合api
function mergeAPI(api) {
  let common = Object.keys(api).reduce((pre, cur) => {
    let module = {};
    if (typeof api[cur] == 'object') {
      module[cur] = mergeAPI(api[cur]);
    } else {
      module[cur] = new ajax(api[cur])
    }
    return Object.assign(pre, module)
  }, {})

  return common;
};

// 封装api方法
function ajax(options) {

  this.fetch = function (options) {
    return new process(options);
  };

  this.mock = function (options, delay = 2000) {
    return new process(options, delay);
  }

  function process(options, delay) {
    let _done = function () { };
    let _fail = function () { };
    let _always = function () { };
    if (!excludeToken.includes(options.url)) {
      axios.defaults.headers = {
        'AdminUserKey-Info': getCookie('AdminUserKey'),
        'AdminUserToken-Info': getCookie('AdminUserToken'),
        'Application-type': 'LC'
      }
    }
    if (delay) {
      new Promise((resolve, reject) => {
        if (options.code === 0 || options.code === 3 || options.code == 'OK') {
          setTimeout(() => {
            options.time && (options.data.serverTime = options.time);
            resolve(options)
          }, delay)
        } else {
          setTimeout(() => {
            reject(options)
          }, delay)
        }
      })
        .then(res => _done(res))
        .catch(res => _fail(res))
        .then(res => {
          _always(res)
        })
    }
    else {
      mergeMethod(options)
        .then(res => {
          if (res.data instanceof ArrayBuffer) {
            const utf8decoder = new TextDecoder()
            const u8arr = new Uint8Array(res.data)
            const temp = utf8decoder.decode(u8arr)
            if (temp.includes("oK\":false\n}")) {
              // store.dispatch('sendMessage', {
              //   type: 'warning',
              //   text: JSON.parse(temp).message || '导出失败'
              // })
              return _fail(JSON.parse(temp))
            }
            _done(res.data)
            return res.data;
          }
          if (res.__proto__.constructor == Blob || (options.params && options.params.responseType) == 'blob' || (options.params && options.params.responseType) == 'arraybuffer') {
            _done(res.data)
            return res.data;
          }
          if (res.data.code == 0 || res.data.code == 3) {
            _done(res.data)
          } else {
            try {
              _fail(res.data)
            } catch (err) {
              console.log(err)
            }
          }
          if (options.setting && options.setting.notTip === true) {

          }
          else {
            if (res.data && unMessageMap.indexOf(options.url) === -1) {
              try {
                if (res.data.code != 0 && res.data.code != -11) {
                  // store.dispatch('sendMessage', {
                  //   type: 'warning',
                  //   text: (res.message || '') || (res.data && res.data.message)
                  // })
                  Vue.prototype.$message.error((res.message || '') || (res.data && res.data.message))
                }
              } catch (err) {

              }
            }
          }
          return res.body
        })
        .then(res => {
          _always(res)
        })
        .catch(res => {
          _fail(res.data)
        })
    }

    this.done = function (cb) {
      cb && (_done = cb);
      return this;
    };

    this.fail = function (cb) {
      cb && (_fail = cb);
      return this;
    };

    this.always = function (cb) {
      cb && (_always = cb);
      return this;
    }
  }

  function mergeMethod({ methods, url, data, params }) {
    return new Promise((resolve, reject) => {
      // console.log(`---${url}--- `, data)
      if (methods == 'get') {
        axios.get(url, {
          params: data
        })
          .then(success)
          .catch(error)
      } else {
        axios.post(url, data, params)
          .then(success)
          .catch(error)
      }

      function success(res) {
        resolve(res)
      }

      function error(error) {
        resolve(error)
      }
    })
  }

  return options.bind(this)
}

export default mergeAPI(apis)
